export enum TTextureSizeEnum {
  "S256" = "a",
  "S512" = "b",
  "S1024" = "c",
  "S2048" = "d",
  "S4096" = "e",
}
